import { CategoryStoreSelectors, CategoryStoreStates } from '@era/stores';
import { createSelector } from '@ngrx/store';
import { CategoryType } from '@rocksoft/shared';
import { DeviceLinkCategory } from './device-link-selection';

const assignableCategoryTypes = new Set<CategoryType>(['Room', 'Bar', 'FrontDesk', 'Housekeeping', 'Kiosk', 'Staff']);

function toDeviceLinkCategory(category: CategoryStoreStates.CategoriesUnion): DeviceLinkCategory {
  return {
    id: category.categoryId,
    categoryType: category.categoryType,
    humanId: category.categoryHumanId,
    displayName: category.categoryDisplayName,
    parentCategoryId: category.parent?.categoryId,
  };
}

export const selectDeviceLinkLocations = createSelector(
  CategoryStoreSelectors.selectAllCategoriesByType('Location'),
  (categories) => categories.map(toDeviceLinkCategory)
);

export const selectDeviceLinkChildren = createSelector(CategoryStoreSelectors.selectAllCategories, (categories) =>
  categories.filter((category) => assignableCategoryTypes.has(category.categoryType)).map(toDeviceLinkCategory)
);

export const selectDeviceLinkUnavailableCategories = CategoryStoreSelectors.selectAllCategoriesByType('Unavailable');
